import { createGlobalStyle } from 'styled-components';
import img from './hM9rFe.jpg';

const DashboardStyle = createGlobalStyle`
body {
    background: url('${img}') no-repeat center center fixed;
    background-size: cover;
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}

.dashboard-page {
    min-height: calc(100vh - 80px);
    padding: 40px 20px 80px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}

.dashboard-page::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 0;
}

.dashboard-container {
    position: relative;
    z-index: 1;
    max-width: 700px;
    width: 100%;
}

.dashboard-welcome {
    background: rgba(255, 255, 255, 0.98);
    border-radius: 16px;
    padding: 30px;
    margin-bottom: 30px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
    animation: slideDown 0.5s ease;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.welcome-content {
    display: flex;
    align-items: center;
    gap: 20px;
}

.welcome-icon {
    width: 60px;
    height: 60px;
    color: #3b82f6;
    flex-shrink: 0;
}

.welcome-avatar {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    object-fit: cover;
    border: 4px solid #3b82f6;
    flex-shrink: 0;
    box-shadow: 0 4px 15px rgba(59, 130, 246, 0.4);
}

.welcome-text h1 {
    font-size: 32px;
    font-weight: bold;
    color: #1f2937;
    margin: 0 0 8px;
}

.dashboard-title {
    font-size: 28px;
    font-weight: 600;
    color: #3b82f6;
    margin: 0;
}

.welcome-text p {
    font-size: 18px;
    color: #6b7280;
    margin: 0;
}

.dashboard-menu {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.menu-item {
    background: rgba(255, 255, 255, 0.98);
    border-radius: 12px;
    padding: 24px;
    display: flex;
    align-items: center;
    gap: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    border-left: 4px solid var(--item-color, #3b82f6);
    animation: slideUp 0.5s ease backwards;
}

.menu-item:nth-child(1) { animation-delay: 0.1s; }
.menu-item:nth-child(2) { animation-delay: 0.2s; }
.menu-item:nth-child(3) { animation-delay: 0.3s; }
.menu-item:nth-child(4) { animation-delay: 0.4s; }
.menu-item:nth-child(5) { animation-delay: 0.5s; }

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.menu-item:hover {
    transform: translateX(8px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
    background: rgba(255, 255, 255, 1);
}

.logout-item {
    border-left-color: #ef4444;
    margin-top: 8px;
}

.logout-item:hover {
    background: rgba(254, 226, 226, 0.98);
}

.menu-icon {
    width: 50px;
    height: 50px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.menu-icon svg {
    width: 100%;
    height: 100%;
}

.menu-content {
    flex: 1;
}

.menu-content h3 {
    font-size: 20px;
    font-weight: bold;
    color: #1f2937;
    margin: 0 0 6px;
}

.menu-content p {
    font-size: 15px;
    color: #6b7280;
    margin: 0;
}

@media (max-width: 768px) {
    .dashboard-page {
        padding: 20px 15px 80px;
    }

    .dashboard-welcome {
        padding: 20px;
    }

    .welcome-content {
        flex-direction: column;
        text-align: center;
    }

    .welcome-icon {
        width: 50px;
        height: 50px;
    }

    .welcome-text h1 {
        font-size: 26px;
    }

    .welcome-text p {
        font-size: 16px;
    }

    .menu-item {
        padding: 20px;
    }

    .menu-icon {
        width: 40px;
        height: 40px;
    }

    .menu-content h3 {
        font-size: 18px;
    }

    .menu-content p {
        font-size: 14px;
    }
}
`;

export default DashboardStyle;
